import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Signup from "../views/Signup.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Welcome",
    component: Signup,
    meta: {
      title: 'FunFangle Organization Signup',
      metaTags: [
        {
          name: 'description',
          content: 'Signup page for a FunFangle organization account.'
        },
        {
          property: 'og:description',
          content: 'Signup page for a FunFangle organization account.'
        }
      ]
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
